module.exports = __webpack_public_path__ + "img/numFour.ceeb57e0.png";